function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M-630.8,655c4-0.6,6.9-3,6.9-5.9c0-3.3-3.8-6.1-8.5-6.1c-4.7,0-8.5,2.7-8.5,6.1 c0,2.6,2.3,4.9,5.7,5.7c0.1,0,0.2,0.1,0.2,0.1c0.6,0.7,1.7,1.8,3.3,2.9c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1 c0.3-0.2,0.4-0.4,0.3-0.7c-0.1-0.4-0.3-1.1-0.4-1.9C-631.1,655.1-631,655-630.8,655z M-631.7,654c-0.2,0-0.4,0.1-0.5,0.2 c-0.1,0.1-0.2,0.3-0.2,0.5c0.1,0.5,0.1,1,0.2,1.5c-1.1-0.9-1.8-1.7-2.2-2.2c-0.1-0.1-0.3-0.2-0.4-0.3c-3-0.7-5-2.6-5-4.7 c0-2.7,3.3-5,7.3-5c4,0,7.3,2.2,7.3,5C-625.2,651.6-628,653.7-631.7,654z"
});

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-livechat",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-641 643 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.81b9ff99.svg";
export { ForwardRef as ReactComponent };